<template>

  <div class="detail_review_list_splide splide">

    <div class="card-title">
      <h3>{{ $t('user-reviews') }}</h3>

      <div class="splide__arrows splide__arrows--ltr">
        <button
            class="splide__arrow splide__arrow--prev"
            type="button"
            aria-label="Previous slide"
            aria-controls="splide01-track">
          <TyIcon icon="ty-arrow-left" width="1rem"/>
        </button>
        <button
            class="splide__arrow splide__arrow--next"
            type="button"
            aria-label="Next slide"
            aria-controls="splide01-track">
          <TyIcon icon="ty-arrow-right" width="1rem"/>
        </button>
      </div>

    </div>

    <div class="splide__track">
      <div class="splide__list">
        <div v-for="review in accommodation.reviews" class="reveiw_item splide__slide"
             :key="review.id + '_item_review' ">
          <div class="card" itemprop="review" itemscope
               itemtype="https://schema.org/Review">
            <div class="card-body">

              <div itemprop="author" itemscope
                   itemtype="https://schema.org/Person">
                <p itemprop="name" class="author-name">
                  {{ review.client.client_name && review.client.client_name.length > 0 ? review.client.client_name : $t('Anonymous') }}
                </p>
              </div>

              <p itemprop="datePublished" class="created_at text-capitalize">{{$t('Hodnotene')}} {{ (new Date(review.created_at)).toLocaleString('sk-SK', { year: 'numeric', month: 'long' }) }}</p>


              <div class="stars-count">

                <div class="badge badge-pill badge-reviews"
                     :class="{'bg-warning': review.rating >3 && review.rating <= 4 , 'bg-success': review.rating > 4, 'bg-danger': review.rating <=3 }">
                  {{ Number(review.rating).toFixed(1).replace('.', ',') }}
                </div>

                <div class="user-rating-count-stars">
                  <div class="default-rating-star">
                    <TyIcon icon="ty-star"/>
                    <TyIcon icon="ty-star"/>
                    <TyIcon icon="ty-star"/>
                    <TyIcon icon="ty-star"/>
                    <TyIcon icon="ty-star"/>
                  </div>

                  <div class="user-rating-star">
                    <div class="rating-star" v-for="star in Math.round(Number(review.rating))">
                      <TyIcon icon="ty-star"/>
                    </div>
                  </div>

                </div>
              </div>

              <div itemprop="reviewRating" itemscope itemtype="https://schema.org/Rating"
                   class="d-none">
                <meta itemprop="worstRating" content="1">
                <span itemprop="ratingValue">{{ Number(review.rating) }}</span>/
                <span itemprop="bestRating">5</span>stars
              </div>


             <div class="text">
               <p class="text-dark text-wrap" v-if="review.text.length > 100" itemprop="reviewBody">
                 {{
                   (review?.lang_text[activeLocale.code] ?? review.text).substring(0, 100) + '...'
                 }}</p>
               <p class="text-dark text-wrap" v-else itemprop="reviewBody">
                 {{ review?.lang_text[activeLocale.code] ?? review.text }}
               </p>
             </div>


            </div>



          </div>
        </div>
      </div>
    </div>
  </div>


</template>

<script setup lang="ts">
import {onMounted, PropType, ref} from 'vue';
import Accommodation from '../../../../../lib/models/Accommodation';
import {formatTime} from "../../../../../lib/functions";
import {useNuxtApp} from "nuxt/app";
import "~/assets/less/detail_review_list_splide.css";


const props = defineProps({
  accommodation: Object as PropType<Accommodation>,
  activeLocale: {code: String}
});
const {$splide} = useNuxtApp();

onMounted(async () => {
  const Splide = await $splide();
  const splide = new Splide('.detail_review_list_splide', {
    type: props.accommodation.reviews.length > 3 ? 'loop' : 'slide',
    speed: 400,
    pagination: false,
    autoplay: false,
    perPage: 3,
    gap: '.75rem',
    arrows: props.accommodation.reviews.length > 3,
    breakpoints: {
      '430': {
        arrows: true,
        perPage: 1,
        padding: { left: '0rem', right: '3rem' }
      },

      '900': {
        arrows: false,
      },
    }
  }).mount();
});
</script>
